import { FormattedMessage } from 'react-intl';

import { Button, Grid, Gutter, Spinner, Tag } from 'components/ui/general';

import { texts } from '../RestaurantProfileModal.text';

import styles from '../RestaurantProfileModal.module.scss';

type RecommendationsSectionProps = {
  loading: boolean;
  locationNames: { id: string | number; name: string }[];
};

export const RecommendationsSection = ({
  loading,
  locationNames,
}: RecommendationsSectionProps) => {
  if (loading) {
    return (
      <Gutter.Item>
        <Spinner
          textAlign="right"
          visible
          color="primary"
          text={<FormattedMessage {...texts.fetchRecommendationsLoading} />}
        />
      </Gutter.Item>
    );
  }

  if (!locationNames.length) {
    return null;
  }

  return (
    <Gutter.Item>
      <Gutter gutter={{ bottom: 2 }}>
        <Gutter.Item>
          <p className={styles.sectionHeading}>
            <FormattedMessage {...texts.recommendedBy} />
          </p>
        </Gutter.Item>
        <Gutter.Item>
          <Grid gutter={{ left: 1, bottom: 1 }}>
            {locationNames.slice(0, 3).map(({ name, id }) => (
              <Grid.Item key={id}>
                <Tag color="mu">{name}</Tag>
              </Grid.Item>
            ))}
          </Grid>
        </Gutter.Item>
      </Gutter>
    </Gutter.Item>
  );
};

type RecommendationsIconProps = {
  loading: boolean;
  total: number;
};

export const RecommendationsIcon = ({
  loading,
  total,
}: RecommendationsIconProps) => (
  <Grid.Item>
    <Button
      color="info"
      size="sm"
      iconLeft={{ name: 'thumbs-up' }}
      viewOnly
      as="div"
      loading={loading}
    >
      {String(total)}
    </Button>
  </Grid.Item>
);
